import React, { useState } from 'react';
import {
  Box,
  Typography,
  Stack,
  TextField,
  Button,
} from "@mui/material";
import IconButton from '@mui/material/IconButton';

const EnterNewPassword = () => {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showNewPasswordMatch, setShowNewPasswordMatch] = useState(false);
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
  });
  const [errorMsg, setErrorMsg] = useState('');

  const handleShowNewPassword = () => {
    setShowNewPassword((prev) => !prev);
  };

  const handleShowNewPasswordMatch = () => {
    setShowNewPasswordMatch((prev) => !prev);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));
    setErrorMsg('');
  };

  const resetPasswordHandle = (e: React.FormEvent) => {
    e.preventDefault();

    const { newPassword, confirmPassword } = formData;

    if (!newPassword || !confirmPassword) {
      setErrorMsg('Please enter both new password and confirm password.');
    } else if (newPassword !== confirmPassword) {
      setErrorMsg('New password and confirm password do not match.');
    } else {
      setErrorMsg('');
      setFormData({
        newPassword: '',
        confirmPassword: '',
      });
      alert('Password successfully updated');
    }
  };

  return (
    <Box>
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 500,
          fontSize: "24px",
          mb: '24px',
        }}
      >
        Reset Password
      </Typography>

      <form onSubmit={resetPasswordHandle}>
        <Typography
          sx={{
            mb: '24px',
            fontSize: '14px',
            textAlign: 'center',
            color: '#FB462E'
          }}
        >
          {errorMsg}
        </Typography>

        <Stack>
          <TextField
            variant="outlined"
            placeholder="Enter New Password"
            className="inputt"
            type={showNewPassword ? 'text' : 'password'}
            value={formData.newPassword}
            onChange={handleChange}
            name='newPassword'
            InputProps={{
              endAdornment: formData.newPassword && (
                <IconButton
                  onClick={handleShowNewPassword}
                  sx={{ color: '#FFFFFF', right: '10px' }}
                >
                  {showNewPassword ? <img
                    src={"closed-eye.svg"}
                    alt="Icon"
                  />
                    :
                    <img
                      src={"openEye"}
                      alt="Icon"
                    />}
                </IconButton>
              ),
              sx: {
                color: '#E2E3E3',
                '& fieldset': {
                  border: '1px solid #313838',
                },
                '& input::placeholder': {
                  color: '#B4B7B8',
                },
                padding: '0px 15px',
                borderRadius: '8px',
                fontSize: '16px',
                mb: '24px'
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: '#313838'
                }
              }
            }}
            error={errorMsg !== ''}
          />
          <TextField
            variant="outlined"
            placeholder="Re-Enter New Password"
            className="inputt"
            type={showNewPasswordMatch ? 'text' : 'password'}
            value={formData.confirmPassword}
            onChange={handleChange}
            name="confirmPassword"
            error={errorMsg !== ''}
            InputProps={{
              endAdornment: formData.confirmPassword && (
                <IconButton
                  onClick={handleShowNewPasswordMatch}
                  sx={{ color: '#FFFFFF', right: '10px' }}
                >
                  {showNewPasswordMatch ?
                    <img
                      src={"closed-eye.svg"}
                      alt="Icon"
                    />
                    :
                    <img
                      src={"openEye"}
                      alt="Icon"
                    />}
                </IconButton>
              ),
              sx: {
                color: '#E2E3E3',
                '& fieldset': {
                  border: '1px solid #313838',
                },
                '& input::placeholder': {
                  color: '#B4B7B8',
                },
                padding: '0px 15px',
                borderRadius: '8px',
                fontSize: '16px',
                mb: '24px'
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: '#313838'
                }
              }
            }}
          />

          <Button type="submit" variant="contained" sx={{ padding: '12px 16px', mb: '24px', fontSize: '14px', fontWeight: 500 }} className='auth-btn'>
            Reset Password
          </Button>
        </Stack>
      </form>
    </Box>
  );
};

export default EnterNewPassword;